<template>
  <div class="w-table w-table--wrap">
    <div class="w-table__scroll-wrap" >
    <table class="w-table" color="light" >
      <thead>
        <tr>
           <th class="w-table__header  text-center" width="1%">BIL</th>
            <th class="w-table__header  text-center">NAMA</th>
            <th class="w-table__header  text-center">CATATAN</th>
            <th class="w-table__header  text-center">TARIKH</th>
            <th class="w-table__header  text-center">TINDAKAN</th>      
        </tr>
      </thead>

      <tbody>
        <template v-for="(dt, ind) in datas" :key="ind">
          <tr class="w-table__row" >
            <td class="w-table__cell text-center" style="padding-top:10px">{{ind+1}}</td>
            <td class="w-table__cell text-center" style="padding-top:10px" >{{dt.nama}}</td>
            <td class="w-table__cell text-center" style="padding-top:10px" >{{dt.remark}}</td>
            <td class="w-table__cell text-center" style="padding-top:10px" >{{dt.created_at}}</td>
            <td class="w-table__cell text-center" >
              
              <w-button dark class="info-dark1--bg" @click="papar(dt)" >
                 <w-icon class="mr1">fal fa-eye</w-icon> PAPAR
             </w-button>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>

 
  <w-dialog
    v-model="dialog_papar.show"
    :fullscreen="dialog_papar.fullscreen"
    :width="dialog_papar.width"
    :persistent="dialog_papar.persistent"
    :persistent-no-animation="dialog_papar.persistentNoAnimation"
    title-class="primary-dark1--bg white"
  >
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Jejak Audit Premis
    </template>

    <div class="w-table-wrap" style="max-height: 400px;">
      <table class="w-table" color="light">
        <thead>
          <tr>
            <!-- Tambah lajur STATUS -->
            <th class="w-table__header text-center" width="10%">STATUS</th>
            <th class="w-table__header text-center">NAMA PENGGUNA</th>
            <th class="w-table__header text-center">ID PREMIS</th>
            <th class="w-table__header text-center">ID EVETPERMIT</th>
            <th class="w-table__header text-center">NAMA PREMIS</th>
            <th class="w-table__header text-center">KAEDAH</th>
            <th class="w-table__header text-center">NO TEL</th>
            <th class="w-table__header text-center">STATUS</th>
            <th class="w-table__header text-center">ALAMAT</th>
            <th class="w-table__header text-center">NEGERI</th>
            <th class="w-table__header text-center">DAERAH</th>
            <th class="w-table__header text-center">BANDAR</th>
            <th class="w-table__header text-center">POSKOD</th>
          </tr>
        </thead>

        <tbody>
          
          <template v-if="selectedAuditDetail.id">
            
            <tr>
              <td class="text-center font-weight-bold">SEBELUM</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.nama ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.no_premis ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.no_premis_vet ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.nama ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.lkp_kaedah ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.no_tel ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.lkp_status ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.alamat ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.lkp_negeri ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.lkp_daerah ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.lkp_bandar ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.lkp_poskod ?? '-' }}</td>
            </tr>
            
            <tr>
              <td class="text-center font-weight-bold">SELEPAS</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.nama ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.no_premis ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.no_premis_vet ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.nama ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.lkp_kaedah ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.no_tel ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.lkp_status ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.alamat ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.lkp_negeri ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.lkp_daerah ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.lkp_bandar ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.lkp_poskod ?? '-' }}</td>
            </tr>
          </template>
          
          <template v-else>
            <tr>
              <td colspan="14" class="text-center">Sila pilih satu rekod untuk dipaparkan.</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <template #actions>
      <div class="spacer"></div>
      <w-button
        style="background-color:#f0f0f0;border:2px solid red;color:#333;font-size:11px;"
        @click="dialog_papar.show = false"
      >
        TUTUP
      </w-button>
    </template>
  </w-dialog>
</div>
</template>

<script>
export default {
  name: "Pemilik",
  props:{
    data: [Array, Object],
  },
  data() {
    return {
      form : {},
      datas : [], 
      selectedAuditDetail: {}, 
      dialog_papar: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1200,
      },
    }
  },
  methods:{
    getData(){
      this.$zcomm.get(this.api_service + 'premis/audit_premis/'+this.data.id, {}).then(res => {
        this.datas = res
      })
    },
    papar(dt){
      this.selectedAuditDetail = dt;
      this.dialog_papar.show = true;
    },
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped>
/* Tambahkan sedikit gaya untuk menjadikan label lebih menonjol */
.font-weight-bold {
  font-weight: bold;
}
</style>